//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import StockAdjustModel from '@/models/Warehouse/WhStockAdjust'
import fields from './fields'

//
export default {
    name: 'stock-adjust-create',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                fields: fields({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                    g_branch_office_selected_id: this.branchOfficeId,
                    triggerWarehouse: this.changeWarehouseFilter,
                    wh_warehouse_id: this.formData.wh_warehouse_id,
                }),
            }
        },

        //
        ...mapState('AuthModule', {
            user: 'user',
        }),
    },
    data() {
        return {
            branchOfficeId: 1,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setAppToolbarTitle: 'setAppToolbarTitle',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        changeWarehouseFilter(ctx) {
            this.branchOfficeId =
                ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
        },

        /**
         *
         */
        create(model) {
            model
                .clone()
                .create()
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'stock-adjust' })
        },

        /**
         *
         */
        reset() {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.formData = new StockAdjustModel()
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(StockAdjustModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Ajuste de stock agregado.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },
    },
    beforeMount() {
        this.setAppToolbarTitle({ title: 'Crear ajuste de stock' })
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_STOCK_ADJUST')) ctx.$router.push('/')
        })
    },
}
